import enLocale from "element-ui/lib/locale/lang/en";
const en = {
  // 单词类
  "登录":"Login",
  "公司":"Company",
  "主页":"HOME",
  "设定":"SETTING",
  "退出":"LOGOUT",
  "努力加载中":"Loading",
  "全部":"All",
  "所有记录":"All Records",
  "海关报表":"Reports",
  "客户记录":"Customer",
  "会员管理": "Member",
  "资金管理":"Funds",
  "资金结余":"Balances",
  "账户管理":"Account",
  "设定汇率":"Rate",
  "小票设定":"Receipt",
  "权限管理":"SuperSU",
  "账号管理":"Account Management",
  "兑换买入":"Cash To Buy",
  "兑换卖出":"For Selling",
  "货币汇款":"Remittance",
  "现金结余": "Cash Balance",
  "银行结余": "Bank Balance",
  "设置汇率":"Rate",
  "":"",
  "":"",
  "":"",
  // element多语言
  ...enLocale
}

export default en
